__turbopack_context__.v({
  "column": "tools-module-scss-module__oVGVYG__column",
  "correctionBtn": "tools-module-scss-module__oVGVYG__correctionBtn",
  "date": "tools-module-scss-module__oVGVYG__date",
  "datesCol": "tools-module-scss-module__oVGVYG__datesCol",
  "dealsListTable": "tools-module-scss-module__oVGVYG__dealsListTable",
  "expandCollapseBtn": "tools-module-scss-module__oVGVYG__expandCollapseBtn",
  "icon": "tools-module-scss-module__oVGVYG__icon",
  "investorSetAvailable": "tools-module-scss-module__oVGVYG__investorSetAvailable",
  "link": "tools-module-scss-module__oVGVYG__link",
  "parentCell": "tools-module-scss-module__oVGVYG__parentCell",
  "region": "tools-module-scss-module__oVGVYG__region",
  "regionCol": "tools-module-scss-module__oVGVYG__regionCol",
  "sponsorCol": "tools-module-scss-module__oVGVYG__sponsorCol",
  "tickerCol": "tools-module-scss-module__oVGVYG__tickerCol",
  "tickerLabel": "tools-module-scss-module__oVGVYG__tickerLabel",
  "tool": "tools-module-scss-module__oVGVYG__tool",
  "toolsCol": "tools-module-scss-module__oVGVYG__toolsCol",
  "verified": "tools-module-scss-module__oVGVYG__verified",
});
